/* eslint-disable camelcase */
/* eslint-disable no-var */
/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
/* eslint-disable no-async-promise-executor */
/* eslint-disable no-console */
/* eslint-disable no-new */
/* eslint-disable arrow-body-style */
import { signInWithEmailAndPassword, createUserWithEmailAndPassword } from 'firebase/auth';
import { ref, set, update, onValue } from 'firebase/database';
import { auth, database, firebaseInit } from './firebaseInit';
import envValues from './enviornment';

const firebaseSignUp = (userData, firebaseConfig) =>
  new Promise(async (resolve, reject) => {
    const datas = await firebaseInit(firebaseConfig);
    if (datas.success === true) {
      const online = true;
      const lastseen = Date.now();
      const user = {
        name: userData.name,
        email: userData.email,
        phone: userData.phone,
        image: userData.image,
        online,
        lastseen,
        avatarRef: userData.avatarRef,
        avatarSource: userData.avatarSource,
        role: userData.role,
      };
      createUserWithEmailAndPassword(auth, userData.email, userData.password)
        .then((data) => {
          const key = data.user.uid;
          localStorage.setItem('user_key', key);
          set(ref(database, `Users/${key}`), user);
          if (key) {
            resolve({ success: true, data: key });
          } else {
            resolve({ success: false, data: 'Error' });
          }
        })
        // eslint-disable-next-line no-console
        .catch((error) => reject(error));
    } else {
      resolve(false);
    }
  });

const firebaseLogin = (userData, firebaseConfig) =>
  new Promise(async (resolve, reject) => {
    const datas = await firebaseInit(firebaseConfig);
    if (datas.success === true) {
      signInWithEmailAndPassword(auth, userData?.email, userData?.password)
        .then((data) => {
          const userId = data.user.uid;
          localStorage.setItem('user_key', userId);
          onValue(
            ref(database, `/Users/${userId}`),
            (snapshot) => {
              const updateData = {
                lastseen: Date.now(),
                online: true,
              };
              update(ref(database, `Users/${data.user.uid}`), updateData);
              if (data.user.uid) {
                resolve({ success: true, data: data.user.uid });
              } else {
                resolve({ success: false, data: 'Error' });
              }
            },
            {
              onlyOnce: true,
            }
          );
        })
        // eslint-disable-next-line no-console
        .catch((error) => reject(error));
    } else {
      resolve(false);
    }
  });

const firebaseLogOut = (current_user) => {
  localStorage.removeItem('user_key');
  new Promise(async (resolve, reject) => {
    const datas = await firebaseInit(envValues.FIREBASE_CONFIG);
    if (datas.success === true) {
      onValue(
        ref(database, `/Users/${current_user}`),
        (snapshot) => {
          // const user_data = snapshot.val();

          const updateBody = {
            online: false,
            lastseen: Date.now(),
          };
          update(ref(database, `/Users/${current_user}`), updateBody)
            .then(() => {
              resolve({ success: true, msg: 'user data updated' });
            })
            .catch((error) => {
              reject(error);
            });
        },
        {
          onlyOnce: true,
        }
      );
    } else {
      resolve(false);
    }
  });
};

const changeUserStatus = (current_user, friend, firebaseConfig) => {
  new Promise(async (resolve, reject) => {
    var friends = [];
    const datas = await firebaseInit(firebaseConfig);
    if (datas.success === true) {
      onValue(
        ref(database, `/Users/${current_user}`),
        (snapshot) => {
          const user_data = snapshot.val();
          if (user_data.friends) {
            friends = user_data.friends;
            friends.push(friend);
          } else {
            friends.push(friend);
          }
          const updateBody = {
            friends,
          };
          update(ref(database, `/Users/${current_user}`), updateBody)
            .then(() => {
              resolve({ success: true, msg: 'user data updated' });
            })
            .catch((error) => {
              reject(error);
            });
        },
        {
          onlyOnce: true,
        }
      );
    } else {
      resolve(false);
    }
  });
};

const addFirebaseUser = (userData) => {
  return new Promise(async (resolve, reject) => {
    try {
      const datas = await firebaseInit(envValues.FIREBASE_CONFIG);
      if (datas.success === true) {
        const online = false;
        const lastseen = '';
        const user = {
          name: userData?.name,
          email: userData?.email,
          phone: userData?.phone ? userData?.phone : '',
          image: userData?.image ? userData?.image : '',
          online,
          lastseen,
          avatarRef: userData?.avatarRef,
          avatarSource: userData?.avatarSource,
          role: userData?.role,
        };

        createUserWithEmailAndPassword(auth, userData.email, userData.password)
          .then((data) => {
            const key = data?.user?.uid;
            if (key) {
              set(ref(database, `Users/${key}`), user)
                .then(() => resolve({ success: true, data: key }))
                .catch((error) => reject(new Error(`Error setting user data: ${error.message}`)));
            } else {
              reject(new Error('Firebase creation failedm'));
            }
          })
          .catch((error) => {
            if (error.code === 'auth/email-already-in-use') {
              resolve({ success: false, message: 'EMAIL_EXISTS' });
            } else {
              reject(new Error(`Firebase error: ${error.message}`));
            }
          });
      } else {
        reject(new Error('Firebase initialization failed'));
      }
    } catch (error) {
      reject(new Error(`Error initializing Firebase: ${error.message}`));
    }
  });
};

export { firebaseLogin, firebaseSignUp, changeUserStatus, firebaseLogOut, addFirebaseUser };
